import * as Actions from './FinancialPlanCapsuleWrapperActions';
import * as FPActions from '../FinancialPlanWrapper/FinancialPlanWrapperActions';

const getClientState = (state, clientId) => state[clientId] || {};
const getCapsuleState = (clientState, capsuleId) => clientState[capsuleId] || {};

export default (state = {}, action) => {
  switch (action.type) {
    case Actions.SET_CAPSULE_FP_ID: {
      const { clientId, capsuleId, fpId, planName } = action;
      const clientState = getClientState(state, clientId);

      return Object.assign({}, state, {
        [clientId]: {
          ...clientState,
          [capsuleId]: {
            ...getCapsuleState(clientState, capsuleId),
            fpId,
            proposed_plan: planName,
          },
        },
      });
    }
    case Actions.SET_CAPSULE_FP_NAME: {
      const { clientId, capsuleId, name } = action;
      const clientState = getClientState(state, clientId);

      return Object.assign({}, state, {
        [clientId]: {
          ...clientState,
          [capsuleId]: {
            ...getCapsuleState(clientState, capsuleId),
            name,
          },
        },
      });
    }
    case FPActions.PLAN_DATA_READY:
      const { clientId } = action;
      const clientState = getClientState(state, clientId);
      return Object.assign({}, state, {
        [clientId]: {
          ...clientState,
          hasData: true,
        },
      });
    default:
      return state;
  }
};
